/**
 * Author:fang.lijuan
 *
 * Time:2018-10-11
 */
'use strict';
angular.module('editAppSignedGJInfoModule', [])
    .controller('editAppsignedGJInfoCtrl', ['$scope', '$state', '$stateParams', '$window', '$modalInstance', 'trsHttpService', 'trsspliceString', 'result', 'modalDialog',
        function($scope, $state, $stateParams, $window, $modalInstance, trsHttpService, trsspliceString, result, modalDialog) {
            initStatus();

            /**
             * [initStatus description]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.successItems = result.successReports;
                $scope.items = [];
                $scope.anthorItem = [];
                $scope.methodname = '';
                angular.forEach(result.REPORTS ? result.REPORTS : result.reports, function(data, index) {
                    if (angular.isUndefined(data.RESULT)) {
                        $scope.anthorItem.push(data);
                    } else {
                        $scope.items.push(data);
                    }
                });
                if (angular.isDefined(result.params.methodname)) {
                    $scope.methodname = result.params.methodname;
                }
                // 判断直接签发参数还是定时签发参数
                if (angular.isDefined(result.params.selectedArray)) {
                    var params = {
                        'serviceid': 'mlf_appoper',
                        'methodname': $scope.methodname,
                        'ObjectIds': [], // trsspliceString.spliceString(result.params.selectedArray, "CHNLDOCID", ','),
                        'ChnlDocIds': [], // trsspliceString.spliceString(result.params.selectedArray, "CHNLDOCID", ','),
                        'ScheduleTime': result.resultDate,
                        'MetaDataIds': [], // trsspliceString.spliceString(result.params.selectedArray, "METADATAID", ',')
                    };
                    $scope.params = params;
                } else {
                    $scope.params = result.params;
                    $scope.copyParams = angular.copy(result.params);
                }
                $scope.status = {
                    sbgpreview: 3,
                };
                $scope.data = {
                    selectedArray: [],
                };
            }
            $scope.cancel = function() {
                $modalInstance.close(false);
            };
            $scope.confirm = function() {
                $scope.params.enforcement = 1;

                /* if (angular.isUndefined(result.params.selectedArray)) {*/
                $scope.params.ChnlDocIds = [];
                $scope.params.ObjectIds = [];
                $scope.params.MetaDataIds = [];

                /* }*/
                if ($scope.items.length > 1) {
                    $scope.params.SrcDocIds = [];
                    for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                        if ($scope.data.selectedArray[i].RESULT.DOC) {
                            $scope.params.ChnlDocIds.push($scope.data.selectedArray[i].RESULT.DOC.ChnlDocIds);
                            $scope.params.ObjectIds.push($scope.data.selectedArray[i].RESULT.DOC.ObjectIds);
                            $scope.params.MetaDataIds.push($scope.data.selectedArray[i].RESULT.DOC.METADATAID);
                        }
                    }
                    $scope.params.ChnlDocIds = $scope.params.ChnlDocIds.join(',');
                    $scope.params.ObjectIds = $scope.params.ObjectIds.join(',');
                    $scope.params.MetaDataIds = $scope.params.MetaDataIds.join(',');
                } else {

                    /* if (angular.isUndefined(result.params.selectedArray)) {*/
                    $scope.params.ChnlDocIds = $scope.items[0].RESULT.DOC.ChnlDocIds !== undefined ? $scope.items[0].RESULT.DOC.ChnlDocIds : $scope.copyParams.ChnlDocIds;
                    $scope.params.ObjectIds = $scope.items[0].RESULT.DOC.ObjectIds !== undefined ? $scope.items[0].RESULT.DOC.ObjectIds : $scope.copyParams.ObjectIds;
                    $scope.params.MetaDataIds = $scope.items[0].RESULT.DOC.METADATAID !== undefined ? $scope.items[0].RESULT.DOC.METADATAID : $scope.copyParams.METADATAID;

                    /* }*/
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {

                    /* trsconfirm.alertType("签发照排成功", "", "success", false, function() {
                        $modalInstance.close("success");
                    }, '', 1500);*/
                    modalDialog.multiReportsAlert(data, '');
                    $modalInstance.close('success');
                });
            };

            /**
             * [selectDoc description]单选
             * @param  {[obj]} item [description]
             * @return {[null]}      [description]
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };

            /**
             * [appPreview description] 网页预览
             * @param   {[type]}  item  [item description] 当前对象
             * @return  {[type]}        [return description]
             */
            $scope.appPreview = function(item) {
                var editPath = 'appPreview';
                var editParams = {
                    siteid: result.params.siteid ? result.params.siteid : $stateParams.siteid,
                    metadataid: item.METADATAID,
                    channelid: item.CHANNELID,
                    chnldocid: item.CHNLDOCID,
                    platform: 2,
                    doctype: 0,
                    // newspapertype: $scope.status.sbgpreview
                };
                var websiteUrl = $state.href(editPath, editParams);
                // selectedArrayCahe($scope.data.selectedArray);
                $window.open(websiteUrl);
            };
        }
    ]);
